import { CompanyProfile } from "~/types/Profile";

const companyProfileDefault: CompanyProfile = {
  _id: "",
  type: "",
  groupId: "",
  profileName: "",
  slug: "",
  deliveryDistricts: [],
  deliveryOptions: {
    products: [],
    paymentTypes: [],
    deliveryTimes: [],
    defaultDeliveryDuration: {
      min: 0,
      max: 0,
    },
    deliveryVehicles: [],
    hoseLengths: [],
    packagings: [],
  },
  description: "",
  imprint: "",
  vatId: "",
  awards: {
    ralCheck: false,
  },
  hasAGB: false,
  hasWithdrawal: false,
  arbiterShowText: false,
  isTesting: false,
  rating: {
    overall: {
      count: 0,
      average: 0,
    },
    lastYear: {
      count: 0,
      average: 0,
    },
  },
  agencyProfiles: [],
  media: {
    logoImageUrls: {
      small: "",
      medium: "",
      large: "",
    },
    profileImages: [],
    withdrawalFileUrl: null,
    agbFileUrl: null,
  },
};

export default companyProfileDefault;
